// extracted by mini-css-extract-plugin
export default {"host":"III_NonManagerials_host__osaAl","target":"III_NonManagerials_target__sOYsc","cardContainerBase":"III_NonManagerials_cardContainerBase__M6yv-"};